import styled from 'styled-components';
import { TProps } from '../types/TProps';

export const Wrapper = styled.div<TProps>`
  background: var(--color-surface);
  color: var(--color-text);
  box-shadow: 0 10px 15px var(--color-shadow);
  border-radius: 5px;
  position: relative;
  text-align: left;
  max-width: calc(100vw - 32px);

  display: flex;
  flex-direction: column;

  ${(props) => (props.overflow !== 'visible' ? 'max-height: 90vh; max-height: 90dvh;' : '')};

  ${(props) => props.width && `width: ${props.width}`};

  .close-icon {
    position: absolute;
    top: 7.5px;
    right: 7.5px;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    width: 44px;
    cursor: pointer;
    color: var(--color-text-muted);
    :hover {
      color: var(--color-link);
    }
  }
`;
